import React from 'react';

export const Fleet = React.lazy(() => import('./FleetDashboard'));
export const Assignment = React.lazy(() => import('./Assignment/Assignment'));
export const Businesses = React.lazy(() => import('./Businesses/Businesses'));
export const Cost = React.lazy(() => import('./Cost/Cost'));
export const Drivers = React.lazy(() => import('./Drivers/Drivers'));
export const Vehicles = React.lazy(() => import('./Vehicles/Vehicles'));
export const Finance = React.lazy(() => import('./Finances/Finance'));
export const Companies = React.lazy(() => import('./Companies/Companies'));
export const Services = React.lazy(() => import('./Services/Services'));
